<template lang="pug">
  div.wrap-module-hiro.f.fh
    div.hiro-content
      //- v-img(src="/img/logo/logo.svg")
      //- span.block.text-center Alternative and Fictional Social Network
      //- div.f.fc.mt12
      //-   div
      //-     a(href="/privacy_policy.pdf" target="brank").fz12.mr8 Privacy Policy
      //-     a(href="/service_terms.pdf" target="brank").fz12.mr8 Service Terms
      //-     a(href="mailto:hello@hackin.wiki").fz12 Contact
      div.wrap-dl-btn.f.fc
        div.f.fc.mr8
          a(href="https://apps.apple.com/us/app/hack-in-%E3%83%8F%E3%83%83%E3%82%AF%E3%82%A4%E3%83%B3/id1592283554" target="brank").cursor-pointer
            img(src="/img/app-dl-btn-ios.svg").btn-pc.s-hide
          a(href="https://apps.apple.com/us/app/hack-in-%E3%83%8F%E3%83%83%E3%82%AF%E3%82%A4%E3%83%B3/id1592283554" target="brank").cursor-pointer
            img(src="/img/app-dl-btn-ios.svg").s-show
        div.f.fc
          a(href="https://play.google.com/store/apps/details?id=in.hack" target="brank").cursor-pointer
            img(src="/img/app-dl-btn-android.svg").btn-pc.s-hide.pr28
          a(href="https://play.google.com/store/apps/details?id=in.hack" target="brank").cursor-pointer
            img(src="/img/app-dl-btn-android.svg").s-show
    div.bg.f.fh
      img(src="/img/hiro-pc-with-logo.png").object-fit-cover.s-hide
      img(src="/img/hiro-sp-with-logo.png").object-fit-cover.s-show
      //- img(src="/img/hiro-pc.png").object-fit-cover
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-module-hiro {
  position: relative;
  height: 80vh;
  .hiro-content {
    position: relative;
    z-index: 1;
    width: 100%;
    height: 100%;
    .wrap-dl-btn {
      position: absolute;
      width: 100%;
      bottom: 18vh;
      .btn-pc {
        // width: 160px;
      }
    }
  }
  .bg {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 0;
    img {
      width: 100%;
      height: 100%;
      // filter: brightness(0.8);
    }
  }
}
</style>

<script>

export default {
  components: {
  },
  props: {
    // data: {
    //   type: Object,
    //   required: true
    // }
  },
  data () {
    return {
      
    }
  },
  methods: {
    onLoggedIn () {
      
    }
  }
}
</script>
